import { Injectable } from '@angular/core';
import { AutoTopupStore } from './auto-topup.store';
import { ApiService } from '../../shared/services/core/api.service';
import { LoggingService } from '../../shared/services/core/logging.service';
import { PaymentService } from '../../shared/services/payment/payment.service';
import { tap } from 'rxjs/operators';
import { AutoTopUpModel } from './models/auto-top-up.model';
import { AutoTopUpSubscriptionModel } from './models/auto-top-up-subscription.model';

@Injectable({ providedIn: 'root' })
export class AutoTopupService {
  constructor(
    private autoTopupStore: AutoTopupStore,
    private paymentService: PaymentService,
    private logService: LoggingService,
    private api: ApiService
  ) {}

  public fetchAutoTopUpSubscriptions() {
    return this.api
      .getAnySingle<AutoTopUpSubscriptionModel>('autoTopUp/subscriptions')
      .pipe(tap(entity => this.autoTopupStore.update(entity)));
  }

  public autoTopUp(autoTopUp: AutoTopUpModel) {
    this.logService.debug('Making request for auto top up', autoTopUp);
    this.api
      .post<AutoTopUpModel>('autoTopUp/topup', autoTopUp)
      .subscribe(response => this.paymentService.process(response, '', '/ecash/failure'));
  }

  public deleteSubscription(model: AutoTopUpModel) {
    return this.api.post<AutoTopUpModel>('autoTopUp/delete', model).pipe(
      tap(() =>
        this.autoTopupStore.update({
          AutoTopUpItems: [{ ...model, HasSubscription: false }]
        })
      )
    );
  }

  public updateSubscription(model: any) {
    return this.api.put<AutoTopUpModel>('autoTopUp', '', model).pipe(
      tap(() =>
        this.autoTopupStore.update({
          AutoTopUpItems: [model]
        })
      )
    );
  }
}
